import axios from "axios";

const baseUrl = `${process.env.REACT_APP_GITO_API_URL}/access-groups`;
//const baseUrl = "https://localhost:7241";

export async function getAllAccessGroups(apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/AccessGroup/get-simple-access-groups`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || 'Failed to fetch access groups');
    }
}

export async function getSimpleAccessGroupsByOperatorOrganizationPublicId(
    operatorOrganizationPublicId,
    apiAccessToken
) {
    try {
        const response = await axios.get(
            `${baseUrl}/AccessGroup/get-simple-access-groups-by-operator-organization-public-id/${operatorOrganizationPublicId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to fetch access groups");
    }
}

export async function getSimpleAccessGroupsByOrganizationPublicId(organizationPublicId, apiAccessToken) {
    const suffix = organizationPublicId ? `/${organizationPublicId}` : "";
    try {
        const response = await axios.get(
            `${baseUrl}/AccessGroup/get-simple-access-groups-by-organization-public-id${suffix}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to fetch access groups");
    }
}

export async function getAccessGroup(publicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/AccessGroup/get-access-group/${publicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to fetch access group");
    }
}

export async function getAccessGroupDetailed(publicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/AccessGroup/get-access-group/${publicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to fetch access group detail");
    }
}

export async function createAccessGroup(accessGroupData, apiAccessToken) {
    /*
    {
  "name": "string",
  "description": "string",
  "hasUniversalSiteAccess": true
}
  */
    try {
        const response = await axios.post(`${baseUrl}/AccessGroup/create-access-group`, accessGroupData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to create access group");
    }
}


export async function updateAccessGroup(groupData, apiAccessToken) {
    /*
   {
  "accessGroupPublicId": "string",
  "name": "string",
  "description": "string",
  "hasUniversalSiteAccess": true,
  "customerPublicIds": [
    "string"
  ],
  "chargingSitePublicIds": [
    "string"
  ]
}
  */
    try {
        const response = await axios.put(`${baseUrl}/AccessGroup/update-access-group`, groupData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to update access group");
    }
}

// Function to delete user
export async function deleteAccessGroup(publicId, apiAccessToken) {
    try {
        await axios.delete(`${baseUrl}/AccessGroup/delete-access-group/${publicId}`, {
            headers: {
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to delete user");
    }
}

export async function addSiteToAccessGroup(accessGroupData, apiAccessToken) {
    /*
    {
  "accessGroupPublicId": "string",
  "chargingSitePublicId": "string"
}
  */
    try {
        const response = await axios.post(`${baseUrl}/AccessGroup/add-site-to-access-group`, accessGroupData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to create access group");
    }
}

export async function deleteSiteFromAccessGroup(accessGroupData, apiAccessToken) {
    /*
    {
  "accessGroupPublicId": "string",
  "chargingSitePublicId": "string"
}
  */
    try {
        await axios.delete(`${baseUrl}/AccessGroup/delete-site-from-access-group`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
            data: accessGroupData,
        });
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to delete user");
    }
}

export async function addCustomerToAccessGroup(accessGroupData, apiAccessToken) {

    try {
        const { accessGroupPublicId, customerPublicId } = accessGroupData;

        const response = await axios.post(
            `${baseUrl}/AccessGroup/add-customer-to-access-group/${accessGroupPublicId}/${customerPublicId}`,
            null, // ingen body beh�vs
            {
                headers: {
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error adding customer to access group:", error);
        throw new Error(error.response?.data?.detail?.message || "Failed to add customer to access group");
    }
}

export async function deleteCustomerFromAccessGroup(accessGroupData, apiAccessToken) {

    try {
        const { accessGroupPublicId, customerPublicId } = accessGroupData;

        await axios.delete(
            `${baseUrl}/AccessGroup/remove-customer-from-access-group/${accessGroupPublicId}/${customerPublicId}`,
            {
                headers: {
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
    } catch (error) {
        console.error("Error deleting customer from access group:", error);
        throw new Error(error.response?.data?.detail?.message || "Failed to delete customer from access group");
    }
}


export async function getSitesForAccessGroup(publicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/AccessGroup/get-sites-for-access-group/${publicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to fetch user");
    }
}

export async function getAccessGroupsForSite(publicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/AccessGroup/get-charging-site-access-groups/${publicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to fetch user");
    }
}

export async function getCustomersForAccessGroups(publicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/AccessGroup/get-customers-for-access-group/${publicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to fetch user");
    }
}

export async function getAccessGroupsForCustomer(publicId, apiAccessToken) {
    try {
        const response = await axios.get(`${baseUrl}/AccessGroup/get-customer-access-groups/${publicId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${apiAccessToken}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.detail?.message || "Failed to fetch user");
    }
}